import { Chip } from '@mui/material';
import { useIntl } from 'react-intl';
import { FormStatus } from '../../../gql';
import { FormStatusType, FormStatusTypeColor } from './types';

export const FormStatusChip = (props: { formStatus: FormStatus }) => {
  const { formatMessage } = useIntl();
  return <Chip label={formatMessage(FormStatusType[props.formStatus])} color={FormStatusTypeColor[props.formStatus]} size='small' />;
};